// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__pcQQv","signatureButtonsRight":"ModalSign_signatureButtonsRight__2EOTM"};